<template>
   <!-- trade top start -->
   <div
      v-if="pid=='0'"
      class="top-nav-tab"
   >
      <ul id="topNavBox" @click="onTradeTopNav">
         <li><router-link :to="{ name: 'Ranking' }" :class="currentPage == 'Ranking'?'active':''">랭킹</router-link></li>
         <li><router-link :to="{ name: 'ItemListStock',   params: {id:'0'} }" :class="currentPage == 'TradeStock'?'active':''">주식거래</router-link></li>
         <li><router-link :to="{ name: 'ItemListFutures',  params: {id:'0'} }" :class="currentPage == 'TradeFutures'?'active':''">선물거래</router-link></li>
         <li><router-link :to="{ name: 'ItemListCoin',  params: {id:'0'} }" :class="currentPage == 'TradeCoin'?'active':''">코인거래</router-link></li>
         <li><router-link :to="{ name: 'ItemListCoinFutures',  params: {id:'0'} }" :class="currentPage == 'TradeCoinFutures'?'active':''" >코인선물</router-link></li> 
         <li><router-link :to="{ name: '' }" @click="onClickTradeResultAll" :class="currentPage == 'TradeResultAll'?'active':''" >투자내역</router-link></li>
         <li v-if="menuRewardOnOff == 'Y' "><router-link :to="{ name: ''}" @click="onClickTradeReward" :class="currentPage == 'TradeReward'?'active':''" >상금수령</router-link></li>
      </ul>
   </div>
   <!-- // trade top end -->


   <div class="league-select-title" v-else>
      <select class="form-select"  @change="onSeletChange" >
      <option
            v-for="(item, index) in applySpaceListEventLeague"      
            :key = index
            :value="item.ID+'^'+item.TYPE"
            :selected="item.ID == pid"
      >
         {{item.NAME}}
      </option>
      
      </select>
   </div>


   
</template>

<script>
// import Config from '../../public/config.js';
// import axios from '@/axios';
import { useStore } from 'vuex';
import { useRouter }from 'vue-router'
import { computed , onMounted, getCurrentInstance } from 'vue'

export default {
   props:{
      pid:{
           type:String,
           default:'0',
           required:false
       },
   },
  
  setup(){
   const router = useRouter();
   const store = useStore();
   const isLogin = computed(() => store.state.user.isLogin);
   const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
   const currentPage = computed(() => store.state.common.currentPage);
   const applySpaceListEventLeague = computed(()=> store.state.hts.applySpaceListEventLeague); 
   const menuRewardOnOff = computed(() => store.state.common.menuRewardState);

   onMounted(()=>{
      // console.log("tradeTopNav~~^^ ",applySpaceListEventLeague.value);
      changeNavScroll();
   })

   const onSeletChange = (e) =>{  
      console.log("onSeletChange : ", e.target.value);
      var arrData = e.target.value.split('^');
      var spaceId = arrData[0];
      var type  = arrData[1];
      var name = '';
      if(type == "S")
      {
         name = 'ItemListStock';
      }
      else if(type == "F")
      {
         name = 'ItemListFutures';
      }
      else if(type == "C")
      {
         name = 'ItemListCoin';
      }
      else if(type == "G")
      {
         name = 'ItemListCoinFutures';
      }
      

      router.replace({
         name: name,
         params: {
            id:spaceId
         }
      })  
         
   }

   const onTradeTopNav = () => {
      var currentNav = document.querySelector('#topNavBox > li > a.active');
      currentNav.scrollIntoView({behavior: "smooth", block: 'nearest', inline: "center"});
   }

   const changeNavScroll = () => {
      setTimeout(() => {
        
         if(document.querySelector('#topNavBox > li > a.active'))
         {
            var name = document.querySelector('#topNavBox > li > a.active').textContent;
            if(name !== '랭킹') {
               onTradeTopNav();
            }
         }

      },300);
   }

    const onClickTradeReward = () => {
        if (isLogin.value) {
          router.push({
            name:'TradeReward'
          });
        } else {
          emitter.emit('EVENT_ALERT',{title:"알림", body: "로그인 후 입장 가능합니다."});
        }
    }

    const onClickTradeResultAll = () => {
        if (isLogin.value) {
          router.push({
            name:'TradeResultAll'
          });
        } else {
          emitter.emit('EVENT_ALERT',{title:"알림", body: "로그인 후 입장 가능합니다."});
        }
    }   

    return {
      onTradeTopNav,
      currentPage,
      applySpaceListEventLeague,
      onSeletChange,
      menuRewardOnOff,
      onClickTradeReward,
      onClickTradeResultAll,
    }
  }
}
</script>

<style>

</style>